import {Stack} from "@mui/material";
import {WarningRounded} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import ReportTable from "../tables/ReportTable";
import {useSetRecoilState} from "recoil";
import {STATE_REPORT_UPDATING} from "../constants/EnelxRecoil";

import FinanceDialog from "../../../component/FinanceDialog";
import ReportsFilter from "../filters/ReportsFilter";

function Reports() {

    const { t } = useTranslation('finance', { keyPrefix: 'enelx' });
    const setReportTableUpdating = useSetRecoilState(STATE_REPORT_UPDATING);
    const [openUploadWarning, setOpenUploadWarning] = useState(false);
    const [uploadErrorMessage, setUploadErrorMessage] = useState<string>(t('import.error-dialog.errors.generic'));

    useEffect(() => {
        setReportTableUpdating(true);
    }, [])

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ReportsFilter/>
            <ReportTable/>
            <FinanceDialog open={openUploadWarning} onClose={() => setOpenUploadWarning(false)} title={t('import.error-dialog.title')} cancelButton={t('import.error-dialog.close')}
                           content={uploadErrorMessage}
                           titleIcon={<WarningRounded color={"error"}/>}
            />
        </Stack>
    )
}

export default Reports;